// extracted by mini-css-extract-plugin
module.exports = {"fab-back-top-box":"fab-back-top_fab-back-top-box__1Esv9","fab-back-top":"fab-back-top_fab-back-top__3fiiY","fab-back-top-text":"fab-back-top_fab-back-top-text__3TpV_"};